// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"U3-z"};